/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import MakeModelTypeAheadGroup from '../../../../components/make-model/make-model-typeahead-group';
import { useMakeModelApprovalPanelProvider } from './make-model-approval-provider';

const MakeAndModelSearchPanel = ({ hasChassis }) => {
  const state = useMakeModelApprovalPanelProvider();

  return (
    <div className="grid-row grid-gap bg-primary-lighter padding-top-2 flex-align-end">
      <MakeModelTypeAheadGroup
        state={state}
        showChassis={hasChassis}
        requiresChassis={state.requiresChassis}
        fieldWrapperClassName="grid-col flex-1 margin-bottom-3"
        labels={{
          bodyMake: 'Make',
          bodyModel: 'Model',
          chassisMake: 'Chassis make',
          chassisModel: 'Chassis model',
        }}
        placeholders={{
          bodyMake: 'Search makes',
          bodyModel: 'Search models',
          chassisMake: 'Search chassis makes',
          chassisModel: 'Search chassis models',
        }}
        preLoadHelpMessages={{
          bodyMake: 'Type to search for makes',
          bodyModel: 'Type to search for models',
          chassisMake: 'Type to search for chassis makes',
          chassisModel: 'Type to search for chassis models',
        }}
      />
    </div>
  );
};

MakeAndModelSearchPanel.propTypes = {
  hasChassis: PropTypes.bool.isRequired,
};

export default MakeAndModelSearchPanel;
